import {
    FETCH_APPOINTMENT_DETAILS_REQUEST,
    FETCH_APPOINTMENT_DETAILS_SUCCESS,
    FETCH_APPOINTMENT_DETAILS_FAILURE,
  } from "./FetchAppointmentDetailsTypes";
  import api from "../../utils/Api";
  
  // Headers
  
  export const fetchAppointmentDetailsRequest = () => {
    return {
      type: FETCH_APPOINTMENT_DETAILS_REQUEST,
    };
  };
  
  export const fetchAppointmentDetailsSuccess = (appointmentDetails) => {
    return {
      type: FETCH_APPOINTMENT_DETAILS_SUCCESS,
      payload: appointmentDetails,
    };
  };
  
  export const fetchAppointmentDetailsFailure = (error) => {
    return {
      type: FETCH_APPOINTMENT_DETAILS_FAILURE,
      payload: error,
    };
  };
  
  export const fetchAppointmentDetails = (appointment_id) => {
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
  
    return async (dispatch) => {
      dispatch(fetchAppointmentDetailsRequest);
      try {
        const response = await api.get("appointment/" + appointment_id, {
          headers: headers,
        });
        const appointmentDetails = response.data.data;
        dispatch(fetchAppointmentDetailsSuccess(appointmentDetails));
      } catch (error) {
        console.log("Redux error - ", error.response);
        const errorMsg = error.message;
        dispatch(fetchAppointmentDetailsFailure(errorMsg));
      }
    };
  };
  